// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IKeytipProps } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";

import { getDefaultKeytipProps } from "@1js/acui-keytip";

export const derivePreviewFlyoutKeytip = memoizeFunction(
  (keytipProps?: IKeytipProps): IKeytipProps | undefined => {
    return keytipProps ? getDefaultKeytipProps(keytipProps, 29) : undefined;
  }
);
